import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
const { Title } = Typography;
import { FormItemProps } from 'antd/lib/form';
import './FormDividerSpace.scss';

export interface VerticalSpaceProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  title: string;
  layout?: Partial<FormItemProps>;
  labelCol?: number;
}

/**
 * Spazio Divider co titolo sezione.
 */
export function FormDividerSpace(props: VerticalSpaceProps) {
  const { title, layout, labelCol, ...divProps } = props;
  // const size = props.size ?? 24;
  const left = labelCol ? labelCol : (layout?.labelCol?.span as number) || 0;
  const right = 24 - left;

  return (
    <div className="form-divider-space" {...divProps}>
      <Row align="stretch">
        <Col className="label-col" span={left}>
          <Divider />
        </Col>
        <Col className="title-col" span={right}>
          <Row align="middle">
            <Col>
              <Title level={5} className="title">
                {title}
              </Title>
            </Col>
            <Col flex="auto">
              <Divider />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
